<div class="row d-flex justify-content-center">
  <div class="card mb-0 logoff-card">
    <div class="logoff"></div>
    <div class="logoff-text-container">
      <span class="spinner-container">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      </span>
      <span class="logoff-text"> {{translate('logging-off')}} </span>
    </div>
  </div>
</div>
